import { Edge, Connection } from "@xyflow/react";
import { ModelNodeInterface } from "@/interfaces/uiNodeInterfaces/ModelNodeInterface";

export function getThemeColorByIndex(index: number, palette: string[]): string {
  if (index < 0 || palette.length === 0) return "#0ea5e9";
  return palette[index % palette.length];
}

export function resolveTargetColor(
  modelNodes: ModelNodeInterface[],
  targetId: string | null | undefined,
  palette: string[],
  colorByNodeId?: Record<string, string>
): string {
  if (!targetId) return "#0ea5e9";
  if (colorByNodeId && colorByNodeId[targetId]) return colorByNodeId[targetId];
  const targetModelNode = modelNodes.find((n) => n.id === targetId);
  if (targetModelNode?.data?.theme) return targetModelNode.data.theme as string;
  const idx = targetModelNode ? modelNodes.findIndex((n) => n.id === targetModelNode.id) : -1;
  return getThemeColorByIndex(idx, palette);
}

export function buildEdgeFromConnect(
  params: Connection,
  modelNodes: ModelNodeInterface[],
  palette: string[],
  colorByNodeId?: Record<string, string>
): Edge | null {
  if (!params.source || !params.target) return null;
  const stroke = resolveTargetColor(modelNodes, params.target, palette, colorByNodeId);
  return {
    id: `e${params.source}-${params.target}-${Math.random() * 100000}`,
    source: params.source,
    target: params.target,
    sourceHandle: params.sourceHandle ?? undefined,
    targetHandle: params.targetHandle ?? undefined,
    animated: true,
    style: { stroke },
  };
}

export function buildEdgeFromIds(
  sourceId: string,
  targetId: string,
  sourceHandle?: string,
  targetHandle?: string,
  modelNodes: ModelNodeInterface[] = [],
  palette: string[] = [],
  colorByNodeId?: Record<string, string>
): Edge {
  const stroke = resolveTargetColor(modelNodes, targetId, palette, colorByNodeId);
  return {
    id: `e${sourceId}-${targetId}-${Math.random() * 100000}`,
    source: sourceId,
    target: targetId,
    sourceHandle,
    targetHandle,
    animated: true,
    style: { stroke },
  };
}


